import { configureStore } from '@reduxjs/toolkit'
import libraryReducer from './slices/librarySlice'
import playReducer from './slices/playSlice'

export default configureStore({
  reducer: {
    library: libraryReducer,
    play: playReducer,
  },
})